import axios from '../config.js';
const resource = '/specialization';

export default {
  get(id='') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.get(`${resource}${id ? `/${id}`: ''}`);
  },
};